import { FC, useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import { CarBrand } from "../../models/responses/carBrand";
import { Col, Row, Spinner } from "react-bootstrap";
import { Eye, Plus } from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { ClientType } from "../../models/enums/clientTypeEnum";
import { getCarBrands } from "../../app/services/carBrandService";

interface Props {}

const CarBrands: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const carBrands: CarBrand[] = useSelector(
    (state: RootState) => state.carBrand.carBrandList || []
  );
  const loadingCarBrands = useSelector(
    (state: RootState) => state.carBrand.isWaitingCarBrandGetResponse
  );
  const clientType = useSelector(
    (state: RootState) => state.clientType.clientType
  );

  const clientTypeLabel =
    clientType === ClientType.Standard ? "Skadeverkstad" : "AD Butik";

  useEffect(() => {
    dispatch(getCarBrands(instance, account));
  }, [account, accounts, dispatch, instance]);

  const openCarBrandHandler = (carBrand: CarBrand) => {
    navigate(`/car-brands/${carBrand.id}`, { relative: "path" });
  };

  return (
    <div>
      <Row className="mb-3">
        <Col>
          <h1>Bilmärken</h1>
        </Col>
        <Col className="text-end">
          <Button
            className="mt-2 ms-2"
            variant="outline-primary"
            href={`/car-brands/add`}
          >
            Lägg till <Plus />
          </Button>
        </Col>
      </Row>

      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th>Namn</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {carBrands.map((carBrand) => (
            <tr
              key={carBrand.id}
              role="button"
              onClick={() => openCarBrandHandler(carBrand)}
            >
              <td>{carBrand.name}</td>
              <td align="center">
                <Eye />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {loadingCarBrands && (
        <>
          <Row className="mb-3">
            <Col className="text-center">
              <Spinner variant="primary" />
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default CarBrands;
